export default "__VITE_ASSET__CT4b$CDP__"